import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'kt-cx-survey',
  templateUrl: './cx-survey.component.html',
  styleUrls: ['./cx-survey.component.scss']
})
export class CxSurveyComponent implements OnInit {

  currentIndex = 0;
  isNew = false;

  surveyNew = {
    name: null,
    active: true,
    content: [{
      title: null,
      description: null,
      type: 'star'
    }],
    settings: {
      notify: {
        notifyAll: true,
        options: {
          turnNotifications: true,
          withMail: false,
          mail: null
        }
      },
      reviewSites: [
        { name: 'Trip Advisor', url: null },
        { name: 'Holiday Check', url: null},
        { name: 'Top Hotels', url: null},
        { name: 'Otel Puan', url: null},
        { name: 'Booking', url: null},
        { name: 'Google', url: null},
        { name: 'Expedia', url: null},
        { name: 'Zoover', url: null}
      ],
      positiveMessage: null,
      negativeMessage: null
    }
  };

  surveys = JSON.parse(localStorage.getItem('surveys')) || [];

  constructor(private mdlctrl: NgbModal) { }

  ngOnInit() {
  }

  open(modal: any, newValue: boolean, index?: number) {
    if (index) {
      this.currentIndex = index;
    }
    this.isNew = newValue;
    this.mdlctrl.open(modal, { size: 'lg', windowClass: 'filter-modal' }).result.then(result => this.isNew = false);
  }

  add() {
    if (this.isNew) {
      this.surveyNew.content.push(
        {
          title: null,
          description: null,
          type: 'star'
        }
      );
    } else {
      this.surveys[this.currentIndex].content.push({
        title: null,
        description: null,
        type: 'star'
      });
    }
  }

  remove(array: any, index: number, newValue?: boolean) {

    if (newValue === false) {
      this.isNew = newValue;
    }

    array.splice(index, 1);

    if (!this.isNew) {
      localStorage.setItem('surveys', JSON.stringify(this.surveys));
      this.surveys = JSON.parse(localStorage.getItem('surveys'));
    }
  }

  save() {
    if (this.isNew) {
      this.surveys.push(this.surveyNew);
      this.surveyNew = {
        name: null,
        active: true,
        content: [{
          title: null,
          description: null,
          type: 'star'
        }],
        settings: {
          notify: {
            notifyAll: true,
            options: {
              turnNotifications: true,
              withMail: true,
              mail: null
            }
          },
          reviewSites: [
            { name: 'tripadvisor', url: null },
            { name: 'holidaycheck', url: null},
            { name: 'tophotels', url: null},
            { name: 'otelpuan', url: null},
            { name: 'booking', url: null},
            { name: 'google', url: null},
            { name: 'expedia', url: null},
            { name: 'zoover', url: null}
          ],
          positiveMessage: null,
          negativeMessage: null
        }
      };
    }

    localStorage.setItem('surveys', JSON.stringify(this.surveys));
    this.surveys = JSON.parse(localStorage.getItem('surveys'));

  }

  switch(tab: number, button: any) {
    const table = document.querySelector(`#tab-${tab}`) as HTMLElement;


    const buttons = document.getElementsByClassName('tabbutton') as any;
    const tabs = document.getElementsByClassName('tabs') as any;

    for (const elem of buttons) {
      elem.classList.remove('active');
    }

    for (const elem of tabs) {
      elem.classList.remove('show');
    }

    button.classList.add('active');
    table.classList.add('show');
  }

  rate(point: number, index: number, length: number, type: string) {

    for (let i = 0; i < length; i++) {
      const all = document.getElementById(`${type}-${index}${i}`) as HTMLElement;
      all.classList.remove('active');
    }

    for (let i = 0; i <= point; i++) {
      const before = document.getElementById(`${type}-${index}${i}`) as HTMLElement;
      before.classList.add('active');
    }
  }
}
